import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useState, useEffect } from "react";
import { IconRefresh } from '@sfx/icons';
import { Button } from "../../../../../Basic/Button";
import Modal from "../../../../../Basic/Modal";
import { UserRequestItem } from "./UserRequestItem";
import CommonLoad from "../../../../../Basic/Spin";
import useSolutions from "../../hooks/useSolutions";
import { makeUuid } from '../../../../utils/utils';

// When the request data change, reset the UserRequestItem
var WrapUserRequestItem = function WrapUserRequestItem(props) {
  var _useState = useState(makeUuid()),
      _useState2 = _slicedToArray(_useState, 2),
      key = _useState2[0],
      setKey = _useState2[1];

  useEffect(function () {
    setKey(makeUuid());
  }, [props.request]);
  return /*#__PURE__*/React.createElement(UserRequestItem, _extends({
    key: key
  }, props));
};

function UserRequestModal(props) {
  var prefix = props.prefix,
      translate = props.translate,
      isOpen = props.isOpen,
      isFetching = props.isFetching,
      requestIds = props.requestIds,
      requests = props.requests,
      onClose = props.onClose,
      onRefresh = props.onRefresh;
  var componentClass = "".concat(prefix, "-user-request-modal");

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      operationIsLoading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      componentRefreshTrigger = _useState6[0],
      setRefresh = _useState6[1];

  var refreshRequestListComponent = useCallback(function () {
    return setRefresh(function (prev) {
      return prev + 1;
    });
  }, []);

  var _useSolutions = useSolutions(),
      refetchSolution = _useSolutions.refetchSolution;

  var handleRefresh = useCallback(function () {
    onRefresh();
    refetchSolution();
  }, [onRefresh, refetchSolution]);
  return /*#__PURE__*/React.createElement(Modal, {
    centered: true,
    backdrop: "static",
    className: "account-settings-modal ".concat(componentClass),
    modalTitle: translate('SFxAccountSettingsUserRequestTitle'),
    footer: null,
    isOpen: isOpen,
    toggle: onClose,
    onCancel: onClose
  }, /*#__PURE__*/React.createElement("h3", {
    className: "".concat(componentClass, "-header")
  }, /*#__PURE__*/React.createElement("span", null, translate('SFxAccountSettingsUserRequestTitle')), /*#__PURE__*/React.createElement(Button, {
    btype: "important",
    icon: /*#__PURE__*/React.createElement(IconRefresh, {
      size: "18"
    }),
    onClick: handleRefresh
  }, translate('SFxAccountSettingsUserRequestRefresh'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-list")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-list-header")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-list-column ").concat(componentClass, "-list-name")
  }, translate('SFxAccountSettingsUserRequestColumnName')), /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-list-column ").concat(componentClass, "-list-requestor")
  }, translate('SFxAccountSettingsUserRequestColumnRequestor')), /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-list-column ").concat(componentClass, "-list-solutions")
  }, translate('SFxAccountSettingsUserRequestColumnSolution')), /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-list-column ").concat(componentClass, "-list-status")
  }, translate('SFxAccountSettingsUserRequestColumnStatus'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-list-container")
  }, requestIds.map(function (id) {
    return /*#__PURE__*/React.createElement(WrapUserRequestItem, {
      key: id,
      prefix: prefix,
      translate: translate,
      setLoading: setLoading,
      request: requests[id],
      onRefresh: handleRefresh,
      refreshRequestListComponent: refreshRequestListComponent
    });
  }))), (operationIsLoading || isFetching) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-mask")
  }, /*#__PURE__*/React.createElement(CommonLoad, {
    size: 0.2
  })));
}

export default UserRequestModal;